import { Component } from '@angular/core';
import { Router } from '@angular/router';

import {GlobalState} from '../../../global.state';

@Component({
    selector: 'ba-content-top',
    styleUrls: ['./baContentTop.scss'],
    templateUrl: './baContentTop.html',
})

export class BaContentTop {

    public activePageTitle:string = '';

    constructor(
        private _state:GlobalState,
        private router: Router
    ) {
        this._state.subscribe('menu.activeLink', (activeLink) => {
            if (activeLink) {
                this.activePageTitle = activeLink.title;
            }
        });
    }
}



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/components/baContentTop/baContentTop.component.ts